import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import { SubmitButton } from "@/common/components/buttons/submit-button/SubmitButton";
import { FormShell } from "@/common/components/forms/FormShell";
import { TextField } from "@/common/components/forms/text-field/TextField";

import {
  eagriFarmSchema,
  type EagriFarmFormValues,
} from "./eagriImport.schema";
import { useCreateEagriFarmMutation } from "./signup.api";

type Props = {
  eagriFarmName: string;
};

const EAgriFarmForm = ({ eagriFarmName }: Props): React.ReactElement => {
  const navigate = useNavigate();
  const createEagriFarmMutation = useCreateEagriFarmMutation();

  const handleSubmit = (values: EagriFarmFormValues) => {
    createEagriFarmMutation.mutate(values.farmName, {
      onSuccess: () => navigate("/signup/import-in-progress"),
      onError: () => navigate("/signup/import-failed"),
    });
  };

  return (
    <FormShell<EagriFarmFormValues>
      initialValues={{ farmName: eagriFarmName }}
      onSubmit={handleSubmit}
      validationSchema={eagriFarmSchema}
      footer={
        <SubmitButton
          data-testid="eagri-create-farm"
          pending={createEagriFarmMutation.isPending}
        >
          <FormattedMessage id="EAgriImport.button.create" />
        </SubmitButton>
      }
    >
      <TextField
        autoComplete="new-password"
        fullWidth
        label={<FormattedMessage id="common.farmName" />}
        name="farmName"
      />
    </FormShell>
  );
};

export { EAgriFarmForm };
